import { useSelector } from "react-redux";
import type { IUser } from "../../types/reducers/authReducer";
import { hasPermission, getDefaultLandingPage } from "../../utils/permissions";

/** Signed-in user, read from the old auth store until the new frame owns the session. */
export const useCurrentUser = (): IUser | null =>
  useSelector((s: any) => (s.authStore?.currentUser ?? null) as IUser | null);

export const useWorkspaceId = (): number | null => useCurrentUser()?.currentWorkspace ?? null;

export const useHasPermission = (permission: string | string[]): boolean =>
  hasPermission(permission, useCurrentUser());

/** Same gate as the super-admin console (PermissionRoute "read_admin_workspaces"). */
export const useIsSuperAdmin = (): boolean => {
  const user = useCurrentUser();
  if (!user) return false;
  return user.role === "super_admin" || hasPermission("read_admin_workspaces", user);
};

/** The SERVER says this session is a super admin viewing as someone (not a local key a customer could set). */
export const useIsImpersonatingSession = (): boolean => !!useCurrentUser()?.is_impersonating;

/** Where a signed-in user belongs (never "/", which is the public marketing page). */
export const useDefaultLandingPage = (): string => getDefaultLandingPage(useCurrentUser());
